<template>
	<div class="page-quem-somos">
	<div class="container">
		<div class="col1">


			<h2>URLinks - Otimizando a sua forma de navegar na internet.</h2>

			<p>O mundo da internet é um vasto universo de informações, que se não forem bem gerenciadas, são subaproveitadas e limitam o usuário a um horizonte restrito e desorganizado de possibilidades.</p>
			<p>Pensando em formas de otimizar o uso da internet e das ferramentas mais utilizadas no dia a dia das pessoas, desenvolvemos uma plataforma que vai muito além de ser um super portal de acesso à internet.</p>
			<p>Criamos um meio de integrar tudo aquilo que a maioria das pessoas mais necessita em um único website, permitindo ao usuário otimizar o seu tempo, gerenciar suas vidas profissional e pessoal, e ainda, ampliar seus horizontes de acesso à informação disponível na internet.</p>

			<h3>Veja o que o URLinks oferece a você:</h3>

			<ul>
				<li>Link Boxes: Organize os seus sites favoritos e mais relevantes através de ícones dispostos em categorias nomeadas de acordo com a sua necessidade (ex.: Música, Vídeos, Educação, Trabalho, etc), para acessá-los com um só clique.</li>
				<li>Minhas Tarefas: Gerencie suas tarefas de forma simples e dinâmica em uma janela que estará sempre visível para você.</li>
				<li>Widgets: Utilize ferramentas como: Calculadora, Clima, Câmbio, Dicionário, Tradutor e muito mais, sem precisar acessar nenhum outro website.</li>
				<li>Personalização total: Mude a posição das caixas de categorias, altere as cores do site, escolha o número de colunas e tamanho dos ícones. Tudo para deixar o URLinks com a sua cara.</li>
				<li>Segurança: Proteja o acesso às categorias com senha e garanta a sua privacidade.</li>
				<li>Economize até 90% do seu tempo acessando seus sites mais utilizados.</li>
				<li>Tenha sempre ao seu alcance aquilo o que precisa em suas tarefas do dia a dia.</li>
				<li>Evite contas atrasadas por esquecimento.</li>
				<li>Utilize o seu gerenciador de tarefas para manter o controle de tudo o que precisa.</li>
				<li>Evite cair em websites pouco seguros.</li>
			</ul>

			<p>Nós damos a você todas as ferramentas para otimizar as suas tarefas do dia a dia e a sua forma de navegar na internet.</p>
			<p>Cadastre-se gratuitamente e viva uma nova experiência.</p>

		</div>
		<div class="col2">
			<img src="images/quem-somos.png" alt="">
		</div>
	</div>
	</div>
</template>
<style>

.page-quem-somos{ padding:40px 0;
  background-color:#00b3bc;
  border-bottom:80px solid #fff;
 }


	.page-quem-somos .container{ display: flex; justify-content: space-between; }
	.page-quem-somos .col1 {
		flex-grow: 1;
		margin-right:38px;
		margin-bottom:20px;
	}
	.page-quem-somos .col2 {
		width:400px;
		flex-shrink: 0;
	}
	.page-quem-somos h2 {
		color:#fff;
		font-size: 30px;
		font-weight: bold;
		margin-bottom:20px;
	}
	.page-quem-somos h3 {
		color:#fff;
		font-size: 30px;
		font-weight: bold;
	}
	.page-quem-somos p {
		margin-bottom:15px;
		color:#333;
		text-align: justify;
		line-height: 1.4;
		color:#fff;
	}
	.page-quem-somos img {
	}
	.page-quem-somos ul {
		list-style: disc;
		margin-left: 20px;
		margin-bottom:30px;
		color:#fff;
	}
	@media (max-width:991px){
		.page-quem-somos { display: block; }
		.page-quem-somos img {
			float:none;
			margin:0 0 20px 0;
		}
	}
</style>

<script>

	import firebase from '@/firebase'
	export default {
		props:{
			task:{ type:String, required: false},
		},
		data() {
			return {
				name: '',
				email: '',
				empresa: '',
				categoria: '',
				pais: '',
				estado: '',
				data_inicio: '',
				data_termino: '',
				tempo: '',
				db: null,
				tasksRef: null,
				isloading:false,
			}
		},
		computed: {
			userId() {
				return this.$store.getters.userId;
			},
		},
		methods:{
			goBack(){
				this.$router.push({name:'home'});
			},
			onSubmit(){
			},

		},
		mounted() {
			document.querySelector('body').className = document.querySelector('body').className.replace(/tema\d+/,'');
			//this.$store.dispatch('setIsLoading',{loading:false});
		},
		beforeDestroy() {
		},
	};
</script>


<style>
</style>
